module.exports = __webpack_public_path__ + "static/media/chat03-3.adc4c827.svg";